export default class EnvHelper {
    static get siteName() {
        return craft.env.siteName;
    }

    static get siteLang() {
        return craft.env.siteLang;
    }

    static get page() {
        return craft.page;
    }
}